<nav class="navbar navbar-light navbar-expand-lg fixed-top " style="display: flex; justify-content: space-between;">
  <div style="display: flex; align-items: center;">
    <img [routerLink]="['']" class="navbar-brand img-responsive" src="assets/images/logo.png" style="margin-left: 40px; cursor: pointer !important;" alt="YourOwnROOM" >

    <li class="nav-item dropdown navbarDropdown">
      <p class="nav-link navbarItems"  href="#" role="button" aria-expanded="false">For Home Owners</p>
      <div class="dropdown-menu">
        <a class="dropdown-item navbarDropdownItem" href="#" [routerLink]="['/becomeanowner']" >Rental Management</a>
        <div class="separator"></div>
        <a class="dropdown-item navbarDropdownItem" href="#" [routerLink]="['/becomeanowner']">Property Management</a>
        <div class="separator"></div>
        <a class="dropdown-item navbarDropdownItem" href="#" [routerLink]="['/propertymanager']">Project Management</a>
      </div>
    </li>
    <li class="nav-item dropdown navbarDropdown">
      <p class="nav-link navbarItems" id="partnerships"  href="#" role="button" aria-expanded="false" disabled>Partnerships</p>
      <div class="dropdown-menu">
        <a class="dropdown-item navbarDropdownItemHeader" href="#">Rental & Property Management</a>
        <a class="dropdown-item navbarDropdownSubItem" href="#" [routerLink]="['/partnerships/fiverings']">Five Rings</a>
        <a class="dropdown-item navbarDropdownSubItem" href="#" [routerLink]="['/partnerships/abhihomes']">Abhi Homes</a>
        <a class="dropdown-item navbarDropdownSubItem" href="#" [routerLink]="['/partnerships/agserhomes']">Agser Homes</a>
        <div class="separator"></div>
        <a class="dropdown-item navbarDropdownItemHeader" href="#">Project Management</a>
        <a class="dropdown-item navbarDropdownSubItem" href="#" [routerLink]="['/partnerships/ygc']">YGC</a>
        <div class="separator"></div>
        <a class="dropdown-item navbarDropdownItemHeader" href="#">Fin-Tech</a>
        <a class="dropdown-item navbarDropdownSubItem" href="#" [routerLink]="['/partnerships/eqaro']">EQARO</a>
      </div>
    </li>
    <li class="nav-item dropdown navbarDropdown">
      <p class="nav-link navbarItems"  href="#" role="button" aria-expanded="false" [routerLink]="['/login']" style="cursor: pointer !important;">Vendors & Brokers</p>
    </li>
    
  </div>
  
  <p *ngIf="user!=undefined" style="padding: 15px" data-toggle="modal" data-target="#userActionModal">
    <fa-icon [icon]="faBars" style="color: black; font-size: 20px;"></fa-icon>
  </p>
  <div *ngIf="user == null && user == undefined" class="loginBtn">
    <p class="navbarItems text-start" (click)="login()" style="cursor: pointer; color: #fff;" >Login / Signup</p>          
  </div>
    
</nav>

<!-- User Action Modal if user is defined -->
<div *ngIf="user!=undefined" class="modal fade userModal" id="userActionModal" tabindex="-1" aria-labelledby="userActionModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered userModalDialog">
    <div class="modal-content userModalContent">
      <div class="modal-header " style="padding-top: 32px; padding-bottom: 32px;">
        <div style="width: 100%; display: flex; justify-content: end; position: absolute; top:0px; right: 5px; cursor: pointer;">
          <fa-icon [icon]="faTimes"  data-dismiss="modal" ></fa-icon>
        </div>
        <div >
          <p  class="user_greet">Welcome, <span *ngIf="user.name != undefined" style="font-weight: 600;">{{user != undefined ? user.name : ''}}</span></p>
        </div>   
      </div>            
      <div class="modal-body" >
          <p class="side_nav_items" *ngIf="user.role == 1 || user.role == 2" (click)="dashboard(user.role)" data-dismiss="modal">Dashboard<span style="float: right;"><fa-icon [icon]="faRight" style="font-size: 12px;"></fa-icon></span></p>
          <p class="side_nav_items" [routerLink]="['editprofile']" data-dismiss="modal"><span style="float: right;"><fa-icon [icon]="faRight" style="font-size: 12px;"></fa-icon></span>Edit Profile</p>
          <p class="side_nav_items logout" (click)="logoutSubmit()" data-dismiss="modal">Logout</p>
      </div>
    </div>
  </div>
</div>
<!--------------------------------------------------Developer Hover Menu -------------------------- -->

<!------------------------------------------------- Schedule Visit form ------------------------------>
<div class="modal fade" id="schVisModal" tabindex="-1" aria-labelledby="schVisModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
        <div class="modal-header">
          <div class="modal-body">
              <div style="display: flex; justify-content: end; position: absolute; top:-10px; right: -5px; cursor: pointer;">
                  <fa-icon [icon]="faTimes" class="fa-sm" data-dismiss="modal" ></fa-icon>
              </div>
              <h1 style="font-weight: 600;"> Schedule a Visit </h1>
              <div>
                <form role="form">
                  <div>
                    <h3 style="font-weight: 500;"> Details: </h3>
                    <div class="row form_row">
                      <div class="form-group col-md-6">
                        <input class="form-control" name="firstname" [ngModel]="visitorFname"  (ngModelChange)="changeFirstName($event)" placeholder="First Name" type="text">
                      </div>
                      <div class="form-group col-md-6">
                        <input class="form-control" name="lastname" [ngModel]="visitorLname" (ngModelChange)="changeLastName($event)" placeholder="Last Name" type="text">
                      </div>
                      
                    </div>
                    <div class="row form_row"> 
                      <div class="form-group col-md-6">
                        <input class="form-control" name="phone" maxlength="10" placeholder="Phone Number" [ngModel]="schlVisit.phone" (ngModelChange)="changePhone($event)" type="text">
                      </div>
                      <div class="form-group col-md-6">
                        <input class="form-control" name="email" [ngModel]="schlVisit.email" (ngModelChange)="changeEmail($event)" placeholder=" Email" type="text">
                      </div>
                    </div>
                    <div class="row form_row">
                      <div class="form-group col-md-6">
                        <input type="text"  class="form-control" name="location" placeholder="Locality" [ngModel]="selectedLoc" (ngModelChange)="selectedLoc = $event" autocorrect="off" autocapitalize="off" spellcheck="off" type="text" #locality>
                      </div>
                      <div class="form-group col-md-6">
                        <select class="form-control" name="city" [ngModel]="schlVisit.city"  (ngModelChange)="changeCity($event)">
                            <option value="city" disabled> City </option>
                            <option *ngFor="let x of citySel" [ngValue]="x.id">{{x.text}} </option>
                        </select> 
                      </div>
                      
                    </div>
                  </div> 
                  <div>
                    <div class="notfs_msg" *ngIf="notf_msg == true">
                      <p> {{ dispMsg }} </p>
                    </div>
                  </div>
                  <div class="row form_row">
                    <div class="col-md-12 d-flex justify-content-center">
                      <button type="button" class="btn btn-primary visit_btn" (click)="onSubmitVisit()"> Submit </button>
                    </div>
                  </div>
                </form>
              </div>
          </div>
        </div>
    </div>
  </div>
</div>

<!-- -------------------------------------------Owner Form ------------------------------------------------------- -->
<div class="modal fade" id="ownerModal" tabindex="-1" aria-labelledby="ownerModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
        <div class="modal-header">
          <div class="modal-body">
              <div style="display: flex; justify-content: end; position: absolute; top:-10px; right: -5px; cursor: pointer;">
                  <fa-icon [icon]="faTimes" class="fa-sm" data-dismiss="modal" ></fa-icon>
              </div>
              <h1 style="font-weight: 600;"> List Your Property</h1>
              <div>
                <form role="form">
                  <div>
                    <h3 class="form_heads"> Owner Details: </h3>
                    <div class="row form_row">
                      <div class="form-group col-md-6">
                        <input class="form-control" name="firstname" [ngModel]="ownerfirstname" (ngModelChange)="changeOwnerFirstName($event)" placeholder="First Name" type="text">              
                      </div>
                      <div class="form-group col-md-6">
                        <input class="form-control" name="lastname" [ngModel]="ownerlastname" (ngModelChange)="changeOwnerLastName($event)" placeholder="Last Name" type="text">              
                      </div>
                      
                    </div>
                    <div class="row form_row"> 
                      <div class="form-group col-md-6">
                        <input class="form-control" name="phone" maxlength="10" placeholder="Phone Number" [ngModel]="bcmOwner.phone" (ngModelChange)="changeOwnerPhone($event)" type="text">              
                      </div>
                      <div class="form-group col-md-6">
                        <input class="form-control" name="email" [ngModel]="bcmOwner.email" (ngModelChange)="changeOwnerEmail($event)" placeholder=" Email" type="text">              
                      </div>
                    </div>
                    <div class="row form_row">
                      <div class="form-group col-md-6">
                        <input class="form-control" name="address" placeholder="Property Address" [ngModel]="bcmOwner.address" (ngModelChange)="changeOwnerAddress($event)" type="text">              
                      </div>
                    </div>
                  </div>
                  <h3 class="form_heads"> Requirements: </h3>
                  <div class="row form_row">
                    <div class="form-group col-md-6">
                      <input type="radio" id="rentalpms" name="rental_program" value="rentalandpms" class="mr-2" [ngModel]="bcmOwner.rentalprog" (ngModelChange)="changeOwnerRentalProgram($event)" >
                        <label for="rentalandpms" class="mr-4">Rental & Property Management</label>
                    </div>
                    <div class="form-group col-md-6">
                        <input type="radio" id="pms" name="rental_program" value="pms" class="mr-2" [ngModel]="bcmOwner.rentalprog" (ngModelChange)="changeOwnerRentalProgram($event)">
                          <label for="pms" class="mr-4" >Property Management</label>
                    </div> 
                  </div>
                  <div *ngIf="rentalPmsProg == true">
                    <div class="row form_row">
                      <div class="form-group col-md-6">
                        <input class="form-control" name="location" placeholder="Property Location" type="text">              
                      </div>
                      <div class="form-group col-md-6">
                        <select class="form-control" name="city" [ngModel]="bcmOwner.city" (ngModelChange)="cityOwnerChange($event)">
                          <option value="city" disabled> City </option>
                          <option *ngFor="let city of citySel" [ngValue]="city.id"> {{ city.text }} </option>
                        </select> 
                      </div>
                    </div>
                    <div class="row form_row">
                      <div class="form-group col-md-6">
                        <input name="startdate" value="startdate" [min]="minOwnerDate" [ngModel]="bcmOwner.startdate" (ngModelChange)="changeOwnerStartDate($event)" 
                        type="text" onfocus="(this.type='date')" class="form-control" id="date">
                      </div>
                      <div class="form-group col-md-6">
                        <select class="form-control" name="tenant_type" [ngModel]="bcmOwner.tenantType" (ngModelChange)="changeOwnerTenType($event)">
                          <option value="tenant_type" disabled> Choice of Tenants </option>
                          <option *ngFor="let ct of tenantChoice" [ngValue]="ct.id"> {{ ct.text }} </option>
                        </select> 
                      </div>
                    </div>
                    <div class="row form_row">
                      <div class="form-group col-md-6">
                        <input type="text" class="form-control" name="rentexps" placeholder="Expected Rent in Rupees" [ngModel]="bcmOwner.expectations" (ngModelChange)="changeOwnerCommExp($event)">
                      </div>
                      <div class="form-group col-md-6">
                        <textarea rows="4" cols="50" class="form-control" name="propspecs" placeholder="Special Requirements(max 120 characters)" maxlength="120" [ngModel]="bcmOwner.specs" (ngModelChange)="changeOwnerPropSpecs($event)" ></textarea>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="pmsProg == true">
                    <div class="row form_row">
                      <div class="form-group col-md-6">
                        <input name="startdate" [min]="minOwnerDate" [ngModel]="bcmOwner.startdate" (ngModelChange)="changeOwnerStartDate($event)"
                                type="text" onfocus="(this.type='date')" class="form-control" id="date">
                      </div>
                      <div class="form-group col-md-6">
                        <select name="serviceType" class="form-control" [ngModel]="bcmOwner.serviceType" (ngModelChange)="changeOwnerServiceType($event)">
                          <option value="0" disabled> Type of Service </option>
                          <option *ngFor="let x of srReqTypesSel" [ngValue]="x.id">{{x.text}} </option>
                      </select>  
                      </div>
                    </div>
                    <div class="row form_row">
                      <div class="form-group col-md-12">
                        <textarea rows="4" cols="50" class="form-control" name="requirements" placeholder="Other Requirements(max 120 characters)" maxlength="120" [ngModel]="bcmOwner.otherreq" (ngModelChange)="changeOwnerOtherReqs($event)"></textarea>
                      </div>
                    </div>
                  </div>
                  <div>
                  <div class="display_validation_msg" *ngIf="notf_msg == true">
                    <p> {{ dispMsg }} </p>
                  </div>
                  <div class="success_msg" *ngIf="success_msg == true">
                    <p> {{ dispMsg }} </p>
                  </div>
                </div>
                  <div class="row form_row">
                    <div class="col-md-12 d-flex justify-content-center">
                      <button type="button" class="btn btn-primary owner_btn" (click)="postOwnerForm()"> Submit </button>
                    </div>
                  </div>
                </form>
              </div>
          </div>
        </div>
    </div>
  </div>
</div>
<!-------------------------------------------Developer Form ---------------------------------------------->
<div class="modal fade" id="developerModal" tabindex="-1" aria-labelledby="devModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
        <div class="modal-header">
          <div class="modal-body">
              <div style="display: flex; justify-content: end; position: absolute; top:-10px; right: -5px; cursor: pointer;">
                  <fa-icon [icon]="faTimes" class="fa-sm" data-dismiss="modal" ></fa-icon>
              </div>
              <h1 style="font-weight: 600;"> List Your Property </h1>
              <div>
                <form role="form">
                  <div>
                    <h3 class="form_heads"> Developer Details: </h3>
                    <div class="row form_row">
                      <div class="form-group col-md-6">
                        <input class="form-control" name="name" [ngModel]="bcmDeveloper.firstname" (ngModelChange)="changeDevFirstName($event)" placeholder=" First Name" type="text">              
                      </div>
                      <div class="form-group col-md-6">
                        <input class="form-control" name="lastname" [ngModel]="bcmDeveloper.lastname" (ngModelChange)="changeDevLastName($event)" placeholder=" Last Name" type="text">              
                      </div>
                    </div>
                    <div class="row form_row">
                      <div class="form-group col-md-6">
                        <input class="form-control" name="email" [ngModel]="bcmDeveloper.email" (ngModelChange)="changeDevEmail($event)" placeholder=" Email" type="text">              
                      </div>
                      <div class="form-group col-md-6">
                        <input class="form-control" name="phone" maxLength="10" [ngModel]="bcmDeveloper.phone" (ngModelChange)="changeDevPhone($event)" placeholder="Phone Number" type="text">              
                      </div>
                    </div>
                  </div>
                  <div>
                    <h3 class="form_heads"> Property Details: </h3>
                    <div class="row form_row">
                      <div class="form-group col-md-6">
                        <input class="form-control" name="address" [ngModel]="bcmDeveloper.address" (ngModelChange)="changeDevAddress($event)" placeholder="Property Address " type="text">              
                      </div>
                      <div class="form-group col-md-6">
                        <input class="form-control" name="zipcode" [ngModel]="bcmDeveloper.zipcode" (ngModelChange)="changeDevZip($event)" placeholder="Property Zipcode " type="text">              
                      </div>
                    </div>
                    <div class="row form_row">
                      <div class="form-group col-md-6">
                        <textarea rows="4" cols="50" class="form-control" name="propspecs" [ngModel]="bcmDeveloper.specs" (ngModelChange)="changeDevPropSpecs($event)"  placeholder="Property Specifications"></textarea>
                      </div>
                      <div class="form-group col-md-6">
                        <textarea rows="4" cols="50" class="form-control" name="commexps" [ngModel]="bcmDeveloper.expectations" (ngModelChange)="changeDevCommExp($event)" placeholder="Commercial Expectations"></textarea>
                      </div>
                    </div>
                    <div class="row form_row">
                      <div class="form-group col-md-6">
                        <select class="form-control" name="tenant_type" [ngModel]="bcmDeveloper.tenantType" (ngModelChange)="changeDevTenType($event)">
                          <option value="tenant_type" disabled> Choice of Tenants </option>
                          <option *ngFor="let ct of tenantChoice" [ngValue]="ct.id"> {{ ct.text }} </option>
                        </select> 
                      </div>
                    </div>
                  </div>
                  <h3 class="form_heads"> Requirements: </h3>
                  <div class="row form_row">
                    <div class="form-group col-md-6">
                      <input type="radio" id="pms" name="rental_program" value="pms" class="mr-2" [ngModel]="bcmDeveloper.rentalprog" (ngModelChange)="changeDevRentalProgram($event)">
                        <label for="pms" class="mr-4">Property Management System</label>
                    </div>
                    <div class="form-group col-md-6">
                        <input type="radio" id="rental_program" name="rental_program" value="rental" class="mr-2" [ngModel]="bcmDeveloper.rentalprog" (ngModelChange)="changeDevRentalProgram($event)">
                          <label for="rental_program" class="mr-4" >Rental Program</label>
                    </div>
                  </div>
                  <div>
                    <div class="display_validation_msg" *ngIf="notf_msg == true">
                      <p> {{ dispMsg }} </p>
                    </div>
                    <div class="success_msg" *ngIf="success_msg == true">
                      <p> {{ dispMsg }} </p>
                    </div>
                  </div>
                  <div class="row form_row">
                    <div class="col-md-12 d-flex justify-content-center">
                      <button type="button" class="btn btn-primary dev_btn" (click)="submitDevForm()"> Submit </button>
                    </div>
                  </div>
                </form>
              </div>
          </div>
        </div>
    </div>
  </div>
</div>
